module.exports = __webpack_public_path__ + "img/lake--icon--gray.95b40e71.svg";